import si from '../data/snapshot-info';
import cd from '../data/cluster-data';

let snapshotRestore = {
  restore : (snapshot, target)=>{
    let $restore = $('.ui-snapshot-restore'),
        $target = $(target).parent();
    if(!$restore.length){
      $restore = $(`<div class="ui-snapshot-restore ui-modal">
        <span class="modal-close">&times;</span>
        <h5>Snapshot restore</h5>
        <h6>${snapshot.snapshot}</h6>
        <form>
        <p>
          <label for="rename_pattern">rename pattern
          <input type="text" id="rename_pattern" name="rename_pattern" placeholder="index_(.+)"></label>
        </p>
        <p>
          <label for="rename_replacement">rename replacement
          <input type="text" id="rename_replacement" name="rename_replacement" placeholder="restored_index_$1"></label>
        </p>
        <p>
          <label for="indices">indices</label>
          <select name="indices" multiple="multiple" id="indices">
          </select>
        </p>
        <p>
          <label for="ignore_unavailable">ignore unavailable indices
          <input type="checkbox" value="true" id="ignore_unavailable" name="ignore_unavailable" checked></label>
        </p>
        <p>
          <label for="flush">include aliases
          <input type="checkbox" value="true" id="include_aliases" name="include_aliases" checked></label>
        </p>
        <p>
          <label for="include_global_state">include global state
          <input type="checkbox" value="true" id="include_global_state" name="include_global_state" checked></label>
        </p>
        </form>
        <button type="button">OK</button>
      </div>`);
      $restore.find('.modal-close').click(()=>{
        $restore.hide()
      });
      $('main').append($restore);
    }else{
      $restore.find('input[type=text]').val('');
      $restore.find('select').empty();
      $restore.find('h6').text(snapshot.snapshot);
      $restore.show();
    }
    $restore.css('margin-top', `${$target.offset().top-140}px`);
    if (snapshot.indices && snapshot.indices.forEach){
      $restore.find('select').append(`<option value="${snapshot.indices.join(',')}" selected>all</option>`);
      snapshot.indices.sort().reverse().forEach(x=>{
        $restore.find('select').append(`<option value="${x}">${x}</option>`);
      });
    } 
    $restore.find('button').off('click').on('click', ()=>{
      if(confirm('Existing data will be deleted and will not be recovered. Do you want to proceed?')){
        let _indices = $restore.find('[name=indices]').val().toString().split(',');
        $.each(cd.cluster.indices, (i,x)=>{
          (_indices.includes(x.name)) && (x.metadata.state === 'open') && si.close(x.name);
        });
        si.restore(snapshot.snapshot, JSON.stringify({
          indices: _indices.join(','),
          ignore_unavailable: $restore.find('[name=ignore_unavailable]').is(':checked'),
          include_global_state: $restore.find('[name=include_global_state]').is(':checked'),
          include_aliases : $restore.find('[name=include_aliases]').is(':checked'),
          rename_pattern: $restore.find('[name=rename_pattern]').val(),
          rename_replacement: $restore.find('[name=rename_replacement]').val()
        }));
        $restore.hide();
      }
    });
  }
}

export default snapshotRestore;



// WEBPACK FOOTER //
// ./src/scripts/ui/snapshot-restore.js